import React from 'react';
import NavLink from 'react-router-dom/NavLink';

import PageTitle from '../../components/PageTitle';

const PageNotFound = () => (
  <div>
    <PageTitle>404</PageTitle>
    <p>Sidan kunde inte hittas</p>
    <NavLink to="/">Gå tillbaka till startsidan</NavLink>
  </div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/views/NotFound/index.js